import type * as React from "react"
import { useIntl } from "react-intl"
import { Badge } from "@/components/ui/badge"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { useFeedback } from "@/components/feedback/FeedbackProvider"

/** "Beta" tag beside the brand name. Signed-in pages open the feedback dialog when it's clicked. */
export function BetaBadge({ feedback = false }: { feedback?: boolean }) {
  const intl = useIntl()
  const badge = <Badge tone="accent">{intl.formatMessage({ id: "beta.badge" })}</Badge>
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{feedback ? <FeedbackBadge>{badge}</FeedbackBadge> : badge}</TooltipTrigger>
        <TooltipContent>{intl.formatMessage({ id: "beta.tip" })}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

function FeedbackBadge({ children }: { children: React.ReactNode }) {
  const intl = useIntl()
  const { setOpen } = useFeedback()
  return (
    <button
      type="button"
      className="cursor-pointer rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
      aria-label={intl.formatMessage({ id: "beta.badge_feedback" })}
      onClick={() => setOpen(true)}
    >
      {children}
    </button>
  )
}
